// composables/useSeoKeywords.js
import { computed } from "vue";
import { useSeoDataStore } from "~/stores/seoDataStore";

export function useSeoKeywords(lesson = null) {
  const seoDataStore = useSeoDataStore();

  const keywords = computed(() => {
    const baseKeywords = [
      "apprentissage",
      "cours en ligne",
      "Longoka",
      "éducation",
      "articles",
      "formations",
      "livres",
      "vêtements",
      "papeterie",
      "artisanat",
      "culture",
      "innovation",
    ];

    if (lesson) {
      if (lesson.title) baseKeywords.push(lesson.title);
      if (lesson.category) baseKeywords.push(lesson.category);
      if (lesson.instructor_name) baseKeywords.push(lesson.instructor_name);
      if (lesson.course_title)
        baseKeywords.push(`formation ${lesson.course_title}`);
    }

    const logIfEmpty = (label, list) => {
      if (!list?.length) {
        console.warn(`⚠️ Les titres de ${label} ne sont pas encore chargés !`);
      }
    };

    const sources = [
      { label: "cours", data: seoDataStore.courseTitles },
      { label: "articles", data: seoDataStore.articleTitles },
      { label: "leçons", data: seoDataStore.lessonTitles },
      { label: "livres", data: seoDataStore.bookTitles },
      { label: "artisanat", data: seoDataStore.craftTitles },
      { label: "vêtements", data: seoDataStore.clothingTitles },
      { label: "fournitures", data: seoDataStore.stationeryTitles },
    ];

    for (const { label, data } of sources) {
      logIfEmpty(label, data);
      baseKeywords.push(...data);
    }

    return baseKeywords.filter(Boolean).join(", ");
  });

  return { seoKeywords: keywords };
}
